import clsx from "clsx";
import type { ChildrenProps, ClassNameProps } from "../types";

/** Props Interface */
interface ButtonGroupProps extends ChildrenProps, ClassNameProps {
	isAttached?: boolean;
}

export function ButtonGroup({ children, isAttached = true, className }: ButtonGroupProps) {
	/** Render */
	return <div className={clsx(isAttached ? "button-group" : "h-stack", className)}>{children}</div>;
}
